<template>
  <SlotModal id="refund-modal" :display="display" @close="$emit('close')" class="!mt-0">
    <RefundForm id="refund-form" :reservation="reservation" @close="$emit('close')" isModal />
  </SlotModal>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue'

import SlotModal from '@/common/components/organisms/SlotModal.vue'
import RefundForm from '@/components/refunds/RefundForm.vue'

import { ReservationDetailedRead } from '@generated/types'

export default defineComponent({
  name: 'RefundModal',
  components: { SlotModal, RefundForm },
  props: {
    reservation: {
      type: Object as PropType<ReservationDetailedRead>,
      required: true,
    },
    display: {
      type: Boolean,
      required: true,
    },
  },
  emits: {
    close: () => true,
  },
})
</script>
